import { render, staticRenderFns } from "./AdminGenerateMarketingEmail.vue?vue&type=template&id=5f079221&scoped=true"
import script from "./AdminGenerateMarketingEmail.vue?vue&type=script&lang=js"
export * from "./AdminGenerateMarketingEmail.vue?vue&type=script&lang=js"
import style0 from "./AdminGenerateMarketingEmail.vue?vue&type=style&index=0&id=5f079221&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f079221",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f079221')) {
      api.createRecord('5f079221', component.options)
    } else {
      api.reload('5f079221', component.options)
    }
    module.hot.accept("./AdminGenerateMarketingEmail.vue?vue&type=template&id=5f079221&scoped=true", function () {
      api.rerender('5f079221', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminGenerateMarketingEmail.vue"
export default component.exports